import { SearchParams } from "@/types/DataTable";
import { trpc } from "@/lib/trpc";

export const useCurrentUserQuery = () => trpc.users.currentUser.useQuery();

export const useUsersQuery = (params: Partial<SearchParams>) => trpc.users.findMany.useQuery(params);

export const useUserQuery = (userId: string, enabled: boolean) =>
    trpc.users.findOne.useQuery(
        { id: userId },
        {
            enabled,
        }
    );


export const useUsersAndInvitationsQuery = (params: Partial<SearchParams>) => trpc.users.findUsersAndInvitations.useQuery(params);
